import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader, Stat } from "@/components/admin/common";
import { DailyChart, MonthlyChart } from "@/components/admin/TrafficChart";
import { api } from "@/lib/api";

export const RangePicker = ({ days, setDays }) => (
  <div className="flex rounded-lg border bg-white p-1">
    {[30, 90, 365].map((d) => <button key={d} data-testid={`range-${d}`} onClick={() => setDays(d)} className={`rounded-md px-3 py-1.5 text-xs ${days === d ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"}`}>{d === 365 ? "12 mesi" : `${d} giorni`}</button>)}
  </div>
);

export const PrivacyNote = () => (
  <p className="mt-6 text-xs text-zinc-400">Metriche aggregate e anonime, senza cookie né indirizzi IP. Le visite da QR sono riconosciute tramite il parametro ?s=qr presente nei QR scaricati. I click su “Salva contatto” indicano download del file .vcf, non contatti effettivamente salvati in rubrica.</p>
);

export default function CardAnalytics() {
  const { id } = useParams();
  const [days, setDays] = useState(30);
  const [card, setCard] = useState(null);
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/cards/${id}`).then((r) => setCard(r.data));
  }, [id]);
  useEffect(() => {
    api.get(`/analytics/cards/${id}`, { params: { days } }).then((r) => setData(r.data));
  }, [id, days]);
  const t = data?.totals || {};
  return (
    <div>
      <Link to="/admin/card" className="mb-6 inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900"><ArrowLeft className="h-4 w-4" />Card</Link>
      <PageHeader eyebrow={`Statistiche · ${card?.client?.name || ""}`} title={card?.name || "…"}><RangePicker days={days} setDays={setDays} /></PageHeader>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
        <Stat label="Visite" value={t.views ?? "–"} testId="card-stat-views" />
        <Stat label="Da QR" value={t.qr_views ?? "–"} testId="card-stat-qr" />
        <Stat label="Click Salva contatto" value={t.vcard_downloads ?? "–"} hint="Download .vcf" testId="card-stat-vcard" />
        <Stat label="Click link" value={t.link_clicks ?? "–"} testId="card-stat-clicks" />
        <Stat label="Condivisioni" value={t.shares ?? "–"} testId="card-stat-shares" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="panel p-6"><div className="eyebrow mb-4">Andamento giornaliero</div>{data && <DailyChart data={data.daily} />}</div>
        <div className="panel p-6"><div className="eyebrow mb-4">Andamento mensile</div>{data && <MonthlyChart data={data.monthly} />}</div>
      </div>
      <div className="panel mt-6 p-6" data-testid="top-links">
        <div className="eyebrow mb-4">Link più cliccati</div>
        {data?.top_links.length ? data.top_links.map((l) => (
          <div key={l.label} className="flex justify-between border-b py-2.5 text-sm last:border-0"><span>{l.label || "—"}</span><span className="tabular-nums">{l.clicks}</span></div>
        )) : <div className="text-sm text-zinc-400">Nessun click nel periodo.</div>}
      </div>
      <PrivacyNote />
    </div>
  );
}
